import { Card, CardContent, CardHeader, CardTitle } from '@repo/shadcn';

import { formatCurrencyInBDT } from '@/utils/currency-formater';

import { useWholesaleCustomerDetails } from './hook';

export const Summary = () => {
    const { data } = useWholesaleCustomerDetails();
    console.log('Wholesale Customer Summary Data:', data);
    return (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            <Card>
                <CardHeader>
                    <CardTitle>Order Counts</CardTitle>
                </CardHeader>
                <CardContent>
                    <div className="grid grid-cols-2 gap-4">
                        <span>
                            <strong>Total Orders:</strong>
                        </span>
                        <span className="text-right">
                            {data?.data?.order_summary.total_orders}
                        </span>
                        <span>
                            <strong>Total Paid Orders:</strong>
                        </span>
                        <span className="text-right">
                            {data?.data?.order_summary.total_paid_orders}
                        </span>
                        <span>
                            <strong>Total Due Orders:</strong>
                        </span>
                        <span className="text-right">
                            {data?.data?.order_summary.total_due_orders}
                        </span>
                    </div>
                </CardContent>
            </Card>
            <Card>
                <CardHeader>
                    <CardTitle>Financial Summary</CardTitle>
                </CardHeader>
                <CardContent>
                    <div className="grid grid-cols-2 gap-4">
                        <span>
                            <strong>Current Due:</strong>
                        </span>
                        <span className="text-right">
                            {formatCurrencyInBDT(
                                data?.data?.order_summary.total_due,
                            )}
                        </span>

                        <span>
                            <strong>Total Paid:</strong>
                        </span>
                        <span className="text-right">
                            {formatCurrencyInBDT(
                                data?.data?.order_summary.total_paid,
                            )}
                        </span>

                        <span>
                            <strong>Total Order Price:</strong>
                        </span>
                        <span className="text-right">
                            {formatCurrencyInBDT(
                                data?.data?.order_summary.total_price,
                            )}
                        </span>

                        <span>
                            <strong>Last Payment:</strong>
                        </span>
                        <span className="text-right">
                            {new Date(
                                data?.data?.order_summary.last_paid,
                            ).toLocaleDateString() || 'N/A'}
                        </span>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
};
